import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-de6cd4a4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "preview-table" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "table-title" }, "数据预览最多展示100条数据", -1))
const _hoisted_3 = /*#__PURE__*/_createTextVNode("暂无数据")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("上一步")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("下一步")

import { Empty } from "ant-design-vue";


import { defineComponent } from "vue";
const __default__ = defineComponent({
  name: "DataPreview",
});

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  data: {
    type: Object,
    default: () => ({}),
  },
  tableHeight: {
    type: Number,
    default: 200,
  },
  columns: {
    type: Array,
    default: () => [],
  },
},
  emits: ["setSteps"],
  setup(__props, { emit }) {

const props = __props



const simpleImage = Empty.PRESENTED_IMAGE_SIMPLE;



const column = props.columns;

function updateStep(step: number) {
  emit("setSteps", step);
}

return (_ctx: any,_cache: any) => {
  const _component_vxe_column = _resolveComponent("vxe-column")!
  const _component_a_empty = _resolveComponent("a-empty")!
  const _component_vxe_table = _resolveComponent("vxe-table")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_col = _resolveComponent("a-col")!
  const _component_a_row = _resolveComponent("a-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_vxe_table, {
      border: "",
      data: __props.data.originalList,
      height: __props.tableHeight
    }, {
      empty: _withCtx(() => [
        _createVNode(_component_a_empty, { image: _unref(simpleImage) }, {
          description: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["image"])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_vxe_column, {
          fixed: "left",
          type: "seq",
          width: "80",
          align: "center",
          title: "序号"
        }),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(column), (item) => {
          return (_openBlock(), _createBlock(_component_vxe_column, {
            field: item.dataIndex || item.key,
            title: item.title,
            "min-width": item.width,
            align: "center",
            "show-overflow": "tooltip"
          }, null, 8, ["field", "title", "min-width"]))
        }), 256))
      ]),
      _: 1
    }, 8, ["data", "height"]),
    _createVNode(_component_a_row, {
      type: "flex",
      align: "center",
      style: {"margin":"20px 0 0"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_a_button, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (updateStep(0)))
            }, {
              default: _withCtx(() => [
                _hoisted_4
              ]),
              _: 1
            }),
            _createVNode(_component_a_button, {
              type: "primary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (updateStep(2)))
            }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})